import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router'

import { GUEST } from '~/scopes/guest/route-names'

type RedirectLocation = Exclude<RouteLocationRaw, string>

/**
 * Redirects a logged-out guest who opens an Intercom link (carrying
 * `is_user_guest=true`) to the guest orders page, forwarding `bm_user_id` so
 * the guest magic-link flow can re-authenticate them.
 *
 * This is wired as `redirection.unauthenticated`, so it only runs when the
 * visitor is rejected at the `unauthenticated` level. Returning `undefined`
 * (no guest flag) lets the auth middleware fall back to the app-level default
 * for that level — the login page in front-office.
 */
export const guestOrdersRedirect = (
  to: RouteLocationNormalized,
): { to: RedirectLocation; skipNext: boolean } | undefined => {
  if (to.query.is_user_guest !== 'true') return undefined

  const bmUserId = to.query.bm_user_id

  return {
    to: {
      name: GUEST.ORDERS,
      ...(typeof bmUserId === 'string' && { query: { bm_user_id: bmUserId } }),
    },
    skipNext: true,
  }
}
